import '../styles/Confirm.scss';

const Confirm = ({ message, callBack, show }) => {
  return (
    <div className={`confirm_container ${show ? 'show' : ''} `}>
      <div
        className={`confirm bg-slate-600 w-5/6 sm:w-1/3 h-1/4 flex flex-col justify-between items-center text-white rounded-lg z-30`}
      >
        <h2 className="my-auto text-2xl">{message}</h2>

        <div className="w-full flex justify-between items-center">
          <button
            onClick={callBack.bind(null, true)}
            className="w-full p-2 bg-red-600 rounded-bl-lg"
          >
            تایید
          </button>
          <button
            onClick={callBack.bind(null, false)}
            className="w-full p-2 bg-yellow-600 rounded-br-lg"
          >
            بازگشت
          </button>
        </div>
      </div>
    </div>
  );
};

export default Confirm;
